// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"style_checkboxWrapper__kL3rZ","checkbox":"style_checkbox__MGjbC","checked":"style_checked__K94ic"};